module.exports = __webpack_public_path__ + "img/logoScalens.ce004275.svg";